import { createSlice } from '@reduxjs/toolkit';

import { PaymentProviderDetailsModel } from '../payments/legacy/models/payments';

type ProviderSliceState = {
  data: {
    paymentConditions: PaymentProviderDetailsModel | undefined;
  };
};

const initialState: ProviderSliceState = {
  data: {
    paymentConditions: undefined,
  },
};

export const selectedProviderSlice = createSlice({
  name: 'selectedProvider',
  initialState,
  reducers: {
    getProviderPaymentCapabilities: (state, action) => {
      state.data.paymentConditions = action.payload;
    },
    resetSelectedProvider: (state) => {
      state.data.paymentConditions = undefined;
    },
  },
});

export const { getProviderPaymentCapabilities, resetSelectedProvider } =
  selectedProviderSlice.actions;
